<template>
  <!-- 一块设置项集合 -->
   <div class="block-setting">
    <basic-setting v-for="(item, index) in settings" :key="index" class="basic-item"
      :config="typeof item === 'string' ? item : item.name"
    />
   </div>
</template>
<script>
import basicSetting from "./basic-setting.vue"
export default {
  components: {
    basicSetting
  },
  props: {
    settings: Array
  }
}
</script>
<style>
.block-setting {
  padding: 12px;
  border-radius: 4px;
  border: 1px solid rgba(233, 233, 233, 1);
  background: rgba(251, 252, 253, 1);
}
.basic-item:not(:last-child) {
  margin-bottom: 12px;
}
</style>
